(() => {
  const tagId = 'AW-11326340272';
  const destinations = {
    phone: `${tagId}/F2lZCNjKkZMdELD56Jgq`,
    whatsapp: `${tagId}/XaSGCNvKkZMdELD56Jgq`
  };
  const preview = new URLSearchParams(window.location.search).has('preview_theme_id');
  if (preview || window.Shopify?.designMode || window.glitzContactTrackingLoaded) return;
  window.glitzContactTrackingLoaded = true;

  const recorded = new Set();
  let configured = false;
  let ownsTag = false;

  const permission = () => {
    const privacy = window.Shopify?.customerPrivacy;
    return Boolean(privacy?.analyticsProcessingAllowed?.() &&
      privacy?.marketingAllowed?.() && privacy?.saleOfDataAllowed?.());
  };

  const consent = (allowed) => ({
    ad_storage: allowed ? 'granted' : 'denied',
    analytics_storage: allowed ? 'granted' : 'denied',
    ad_user_data: allowed ? 'granted' : 'denied',
    ad_personalization: 'denied'
  });

  const configure = () => {
    if (!permission()) {
      if (ownsTag && configured) window.gtag('consent', 'update', consent(false));
      return false;
    }
    if (configured) {
      if (ownsTag) window.gtag('consent', 'update', consent(true));
      return true;
    }
    if (typeof window.gtag !== 'function') {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      ownsTag = true;
      window.gtag('consent', 'default', consent(false));
      window.gtag('consent', 'update', consent(true));
      window.gtag('js', new Date());
    }
    window.gtag('config', tagId, {
      send_page_view: false,
      allow_ad_personalization_signals: false,
      allow_google_signals: false
    });
    configured = true;
    if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${tagId}`;
      document.head.appendChild(script);
    }
    return true;
  };

  const kindOf = (href) => {
    if (/^tel:/i.test(href)) {
      const digits = href.slice(4).replace(/\D/g, '');
      return ['7182348664', '17182348664'].includes(digits) ? 'phone' : null;
    }
    try {
      const url = new URL(href, window.location.origin);
      if (url.protocol !== 'https:') return null;
      const digits = url.hostname === 'wa.me'
        ? url.pathname.replace(/\D/g, '')
        : ['api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname)
          ? (url.searchParams.get('phone') || '').replace(/\D/g, '')
          : '';
      return digits === '17182348664' ? 'whatsapp' : null;
    } catch (_) {
      return null;
    }
  };

  document.addEventListener('click', (event) => {
    if (!event.isTrusted || event.button !== 0 || event.defaultPrevented) return;
    const anchor = event.target.closest?.('a[href]');
    if (!anchor) return;
    const kind = kindOf(anchor.getAttribute('href') || '');
    if (!kind || recorded.has(kind) || !configure()) return;
    recorded.add(kind);
    window.gtag('event', 'conversion', {
      send_to: destinations[kind],
      value: 0,
      currency: 'USD'
    });
  });

  document.addEventListener('visitorConsentCollected', configure);
  const init = () => {
    if (window.Shopify?.customerPrivacy) {
      configure();
    } else if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }],
        (error) => { if (!error) configure(); });
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
